/* globals angular */
( function () {
	'use strict';

	function pdfRtfParser () {
		var buildText, buildBold, buildItalic, buildUnderline, buildNewLine, buildUnorderedList, buildOrderedList, buildList, buildSpan, buildWrapper, mapChildNodes;

		function convertToHtml ( htmlString ) {
			return angular.element( htmlString.replace( /\t/g, '' ).replace( /\n/g, '' ) );
		}

		function flattenArray ( arr ) {
			return [].concat.apply( [], arr );
		}

		function removeUndefined ( item ) {
			return item;
		}

		function performMapOnChildNode ( node ) {
			var child = node.childNodes;

			return [].map.call( child, mapChildNodes ).filter( removeUndefined );
		}

		buildText = function buildTextFn ( node ) {
			return {
				'text' : node.nodeValue
			};
		};

		function applyBoldStyle ( textObj ) {
			textObj.bold = true;
			return textObj;
		}

		buildBold = function buildBoldFn ( node ) {
			var mappedArr = performMapOnChildNode( node );
			var flatArr   = flattenArray( mappedArr );

			return flatArr.map( applyBoldStyle );
		};

		function applyItalicStyle ( textObj ) {
			textObj.italics = true;
			return textObj;
		}

		buildItalic = function buildItalicFn ( node ) {
			var mappedArr = performMapOnChildNode( node );
			var flatArr   = flattenArray( mappedArr );

			return flatArr.map( applyItalicStyle );
		};

		function applyUnderlineStyle ( textObj ) {
			textObj.decoration = 'underline';
			return textObj;
		}

		buildUnderline = function buildUnderlineFn ( node ) {
			var mappedArr = performMapOnChildNode( node );
			var flatArr   = flattenArray( mappedArr );

			return flatArr.map( applyUnderlineStyle );
		};

		buildNewLine = function buildNewLineFn () {
			return {
				'text' : '\n'
			};
		};

		function filterWrapperElement ( item ) {
			return item.nodeName === 'UL' || item.nodeName === 'OL';
		}

		function hasListWrapperElement ( childNode ) {
			return Boolean( [].filter.call( childNode, filterWrapperElement ).length );
		}

		function formatNestedList ( array ) {
			var elemObj, elemArr;

			var listObjArr = [];
			var isList     = false;

			elemArr = array.filter( function ( item ) {
				isList = false;
				if ( item.ul || item.ol ) {
					isList = true;
					listObjArr.push( item );
				}
				return !isList;
			} );

			elemObj = {
				'text' : elemArr
			};
			return [ elemObj, listObjArr ];
		}

		buildList = function buildListFn ( node ) {
			var newArr;
			var child        = node.childNodes;
			var mappedArr    = [].map.call( child, mapChildNodes ).filter( removeUndefined );
			var hasListChild = hasListWrapperElement( child );
			var returnedList = mappedArr;

			if ( hasListChild ) {
				newArr       = angular.copy( flattenArray( mappedArr ) );
				returnedList = formatNestedList( newArr );
			} else {
				returnedList = {
					'text' : flattenArray( mappedArr )
				};
			}

			return returnedList;
		};

		buildOrderedList = function buildOrderedListFn ( node ) {
			var mappedArr = performMapOnChildNode( node );

			var orderdList = {
				'ol'     : mappedArr,
				'margin' : [ 15, 5, 0, 5 ]
			};

			return orderdList;
		};

		buildUnorderedList = function buildUnorderedListFn ( node ) {
			var mappedArr = performMapOnChildNode( node );

			var unorderdList = {
				'ul'     : mappedArr,
				'margin' : [ 15, 5, 0, 5 ]
			};

			return unorderdList;
		};

		buildSpan = function buildSpanFn ( node ) {
			var mappedArr = performMapOnChildNode( node );

			return flattenArray( mappedArr );
		};

		buildWrapper = function buildWrapperFn ( node ) {
			var child     = node.childNodes;
			var mappedArr = [].map.call( child, mapChildNodes ).filter( removeUndefined );
			var margin    = parseInt( ( node.style.marginLeft ).replace( 'px', '' ) || 0, 10 );

			return {
				'text'   : flattenArray( mappedArr ),
				'margin' : [ margin, 0, 0, 10 ]
			};
		};

		mapChildNodes = function mapChildNodesFn ( node ) {
			var type = node.nodeName;

			var buildObj = {
				'#text'  : buildText,
				'STRONG' : buildBold,
				'B'      : buildBold,
				'EM'     : buildItalic,
				'I'      : buildItalic,
				'U'      : buildUnderline,
				'BR'     : buildNewLine,
				'UL'     : buildUnorderedList,
				'OL'     : buildOrderedList,
				'LI'     : buildList,
				'SPAN'   : buildSpan,
				'P'      : buildWrapper
			};

			return ( buildObj[ type ] || angular.noop )( node ) || '';
		};

		function mapElements ( index, element ) {
			var mapArr  = [].map.call( [ element ], mapChildNodes );
			var flatArr = flattenArray( mapArr );

			return flatArr;
		}

		function removeDomAttributes ( arr ) {
			var newArr = [];

			for ( var i = 0; i < arr.length; i++  ) {
				newArr.push( arr[ i ] );
			}
			return newArr;
		}

		function attachP ( cond, str ) {
			return cond && str || '';
		}

		function doWrapWithP ( htmlString, isNotWrapped ) {
			return attachP( isNotWrapped, '<p>' ) + htmlString + attachP( isNotWrapped, '</p>' );
		}

		function preParse ( htmlString ) {
			return doWrapWithP( ( htmlString || '' ).trim(), !/^\<(p|ul|ol)\>.*\<\/(p|ul|ol)\>$/.test( htmlString ) );
		}

		function parse ( htmlString ) {
			var html = convertToHtml( preParse( htmlString ) );

			return removeDomAttributes( html.map( mapElements ) );
		}

		return {
			'parse' : parse
		};
	}

	angular
		.module( 'app.components' )
		.factory( 'pdfRtfParserObs', pdfRtfParser );
} )();
